import { map, find, findLastIndex, indexOf } from 'lodash';

const INTERSECTION_THRESHOLD = 0.49;

class TransitionObserver {
  constructor(rowRefs, onTransition) {
    this.rowRefs = rowRefs;
    this.rowStates = map(rowRefs, () => ({}));
    this.onTransition = onTransition;
  }

  static instantiateObserver = (callback, options) => {
    return new window.IntersectionObserver(callback, options);
  };

  handleEntries(entries) {
    entries.forEach(entry => {
      const ref = find(this.rowRefs, rowRef => rowRef.current.id === entry.target.id);
      const refIndex = indexOf(this.rowRefs, ref);

      if (entry.intersectionRatio > INTERSECTION_THRESHOLD) {
        this.rowStates[refIndex].isActive = true;
      } else {
        const hasReachedEnd =
          refIndex === this.rowRefs.length - 1 && !this.rowStates[refIndex - 1].isActive;
        if (!hasReachedEnd) {
          this.rowStates[refIndex].isActive = false;
        }
      }
    });

    const lastActiveIndex = findLastIndex(this.rowStates, ({ isActive }) => isActive);

    const activeRowIndex = lastActiveIndex === -1 ? 0 : lastActiveIndex;
    this.onTransition(activeRowIndex);
  }

  observe() {
    this.observer = TransitionObserver.instantiateObserver(entries => this.handleEntries(entries), {
      threshold: [INTERSECTION_THRESHOLD],
    });
    this.rowRefs.forEach(ref => this.observer.observe(ref.current));
  }

  unobserve() {
    this.rowRefs.forEach(ref => this.observer.unobserve(ref.current));
  }
}

export default TransitionObserver;
